export { default } from './DialogContent';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/DialogContent/index.js
// module id = 131
// module chunks = 0